/**
 * Bestselling Products Custom Web Component Engine
 * Handles deferred external script asset loading structures smoothly without UI breaks
 */
if (!customElements.get('bestselling-products-carousel')) {
  customElements.define('bestselling-products-carousel', class BestsellingProductsCarousel extends HTMLElement {
    connectedCallback() {
      this.swiperContainer = this.querySelector('.bestselling-carousel__swiper');
      if (!this.swiperContainer) return;

      // Extract dynamic configurations cleanly from HTML markup data variables
      this.slidesDesktop = parseFloat(this.getAttribute('data-slides-desktop')) || 4;
      this.slidesTablet = parseFloat(this.getAttribute('data-slides-tablet')) || 2.5;
      this.slidesMobile = parseFloat(this.getAttribute('data-slides-mobile')) || 1.3;

      this.initLifecycle();
    }

    initLifecycle() {
      // If vendor file parsed instantly, activate layout execution threads directly
      if (typeof Swiper !== 'undefined') {
        this.bootCarousel();
      } else {
        // Run clean thread loops checking for asynchronous resolution window closures
        this.pollForVendorScript();
      }
    }

    pollForVendorScript() {
      let trackingAttempts = 0;
      const securityThreshold = 50; // Safeguard limits at 5 seconds maximum running runtimes

      const executionThread = setInterval(() => {
        trackingAttempts++;

        if (typeof Swiper !== 'undefined') {
          clearInterval(executionThread);
          this.bootCarousel();
        } else if (trackingAttempts >= securityThreshold) {
          clearInterval(executionThread);
          console.warn('Bestselling Carousel Component: Swiper core asset could not resolve successfully.');
        }
      }, 100);
    }

    bootCarousel() {
      // Security return guarding initialization states
      if (this.carouselInstance) return;

      // Contextually query structural section-specific tracking arrows elements safely 
      const sectionWrapper = this.closest('.bestselling-carousel');
      const prevElement = sectionWrapper ? sectionWrapper.querySelector('[data-carousel-prev]') : null;
      const nextElement = sectionWrapper ? sectionWrapper.querySelector('[data-carousel-next]') : null;

      this.carouselInstance = new Swiper(this.swiperContainer, {
        slidesPerView: this.slidesMobile,
        spaceBetween: 16,
        grabCursor: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: nextElement,
          prevEl: prevElement,
        },
        breakpoints: {
          600: {
            slidesPerView: this.slidesTablet,
            spaceBetween: 16
          },
          990: {
            slidesPerView: this.slidesDesktop,
            spaceBetween: 24
          }
        },
        on: {
          init: () => {
            // Unbind internal loading layout shields right as transition tracks bind successfully
            this.swiperContainer.classList.remove('bestselling-carousel__swiper--loading');
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.carouselInstance && typeof this.carouselInstance.destroy === 'function') {
        this.carouselInstance.destroy(true, true);
      }
    }
  });
}